import { Checkbox } from '@mantine/core'
import classes from './Checkbox.module.css'

export const CheckboxThemeKobo = Checkbox.extend({
  classNames: classes,
})
